<template>
    <div>
        <span v-show="!isLoading && !dancers.length">暂无舞者</span>
        <ul class="video-lists-box">

            <li class="video-lists" v-for="v in dancers" :key="v.id">
                <div class="dancer-lists-link">
                    <router-link class="dancer-thumb-link pr" :to="`/dancers/${v.id}`"><img class="dancer-thumb" v-lazy="{src: v.thumb, error: 'https://img.vhiphop.com/web/loading-1.gif', loading: 'https://img.vhiphop.com/web/loading-1.gif'}" :alt="v.name"></router-link>

                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <router-link :to="`/dancers/${v.id}`" class="dancer-title-link">
                                <h3 class="video-title ellipsis">{{v.name}}</h3>
                            </router-link>

                            <span class="dancer-tips ellipsis">{{v.tips}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="dancer-counts" :title="`人气值: ${v.views}`">
                                <i class="icon-hot"></i> {{$view(v.views)}}
                            </span>
                                <span class="dancer-counts" title="关注舞者">
                                <i class="icon-liked"></i> {{v.fans}}
                            </span>
                        </p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            dancerTotal: Number,
        },
        data: () => ({
            dancers: [],
            isLoading: true,
        }),
        computed: {
            id () {
                return +this.$route.params.id || 0;
            },
            page() {
                return +this.$route.query.page || 1;
            },
        },
        methods: {
            currentChange(page) {
                this.$router.push(`?page/${page}`);
            },
        },
        async beforeMount() {
            this.dancers = await this.api.get(`studios/${this.id}/dancers`, {page: this.page}).catch(this.err);
            this.isLoading = false;
        },
        async beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            this.isLoading = true;
            let {page} = to.query;
            this.dancers = await this.api.get(`studios/${this.id}/dancers`, {page}).catch(this.err);
            this.isLoading = false;
            next();
        },
    }
</script>

<style scoped>
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/dancer/lists.css";
</style>



// WEBPACK FOOTER //
// src/views/studio/Dancer.vue